import axios, { AxiosError, AxiosResponse } from "axios";
import { NetworkError, UnexpectedError } from "./Errors";
import { CountryCode } from "../common/region_helper";

export type LeadCapturePerson = {
  id: string;
  name: string;
};

const URL = "/lead-capture-persons/";

/**
 * Fetch the list of {@link LeadCapturePerson}s for the given country code.
 *
 * @param countryCode
 * @returns A list of {@link LeadCapturePerson} objects.
 * @throws {NetworkError}
 * @throws {UnexpectedError}
 */
export async function fetchLeadCapturePersons(
  countryCode: CountryCode
): Promise<LeadCapturePerson[]> {
  let result: AxiosResponse<LeadCapturePerson[]>;

  try {
    result = await axios.get(URL + countryCode);
  } catch (error) {
    if ((<AxiosError>error).response) {
      const err = <AxiosError>error;
      throw new NetworkError(
        "Error while reportig school not found.",
        err.response?.status
      );
    }
    throw new UnexpectedError(
      `Error while reportig school not found. ${error}`
    );
  }

  return result.data;
}
